import AdbFormItem from './src/adb-form-item.vue';

AdbFormItem.install = function (Vue) {
  Vue.component(AdbFormItem.name, AdbFormItem);
};

export default AdbFormItem;
